module.exports = exports = require('./pls');
exports.Utils = require('./utils');
exports.OPLS = require('./opls');



//////////////////
// WEBPACK FOOTER
// ./~/ml-pls/src/index.js
// module id = 88
// module chunks = 0